import _ from 'lodash';
import * as types from './types';
import moment from 'moment';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ManageProcessOrderEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  manageOrderListData: {
    GetData: [],
    ConsolidateOrderSummaries: [],
    Errors: [],
  },
  siteListData: [],
  loading: false,
  fetchingSites: false,
  closing: false,
  printLoading: false,
  resetPageOnDataChange: false,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.MANAGE_ORDER_ITEM_LIST:
      return {
        ...state,
        manageOrderListData: {
          ...state.manageOrderListData,
          GetData: action.payload.OrderSummaries.map(item => ({
            ...item,
            [ManageProcessOrderEnum.DeliveryDate]: item[
              ManageProcessOrderEnum.DeliveryDate
            ]
              ? moment(item[ManageProcessOrderEnum.DeliveryDate]).format(
                  DATE_FORMAT_FOR_UI
                )
              : '',
            [ManageProcessOrderEnum.OrderDate]: item[
              ManageProcessOrderEnum.OrderDate
            ]
              ? moment(item[ManageProcessOrderEnum.OrderDate]).format(
                  DATE_FORMAT_FOR_UI
                )
              : '',
            [ManageProcessOrderEnum.OrderTypeName]: item[
              ManageProcessOrderEnum.OrderTypeName
            ].join(','),
            [ManageProcessOrderEnum.ConsolidateOrders]: item[
              ManageProcessOrderEnum.ConsolidateOrders
            ]
              ? item[ManageProcessOrderEnum.ConsolidateOrders].map(order => ({
                  ...order,
                  [ManageProcessOrderEnum.DeliveryDate]: order[
                    ManageProcessOrderEnum.DeliveryDate
                  ]
                    ? moment(order[ManageProcessOrderEnum.DeliveryDate]).format(
                        DATE_FORMAT_FOR_UI
                      )
                    : '',
                  [ManageProcessOrderEnum.OrderDate]: order[
                    ManageProcessOrderEnum.OrderDate
                  ]
                    ? moment(order[ManageProcessOrderEnum.OrderDate]).format(
                        DATE_FORMAT_FOR_UI
                      )
                    : '',
                }))
              : null,
          })),
          Errors: [],
        },
      };

    case types.MANAGE_ORDER_SITE_LIST:
      return {
        ...state,
        siteListData: action.payload,
      };

    case types.MANAGE_ORDER_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.MANAGE_ORDER_CLEAR_GRID_DATA: {
      return {
        ...state,
        loading: false,
        manageOrderListData: INITIAL_STATE.manageOrderListData,
      };
    }

    case types.FETCHING_SITES: {
      return {
        ...state,
        fetchingSites: action.payload,
      };
    }
    case types.MANAGE_ORDER_ERROR:
      const manageOrderResponse = action.payload.response;
      if (
        _.has(manageOrderResponse, 'data.Errors') &&
        manageOrderResponse.data.Errors.length
      ) {
        return {
          ...state,
          manageOrderListData: {
            ...state.manageOrderListData,
            Errors: manageOrderResponse.data.Errors,
          },
        };
      }

      const Errors = [
        {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching Order Summary. Please try again.',
        },
      ];

      return {
        ...state,
        manageOrderListData: {
          ...state.manageOrderListData,
          Errors,
        },
      };

    case types.FETCH_ALL_SITE_ERROR:
      const fetSiteErrorResponse = action.payload.response;
      if (
        _.has(fetSiteErrorResponse, 'data.Errors') &&
        fetSiteErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchingAllSiteError: fetSiteErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        fetchingAllSiteError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving all sites. Please try again.',
        },
      };

    case types.MANAGE_ORDER_LOADING_ONCLOSE:
      return {
        ...state,
        closing: action.payload,
      };
    case types.PRINT_PREVIEW_PROCESS_ORDER_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };
    case types.RESET_TABLE_PAGE_FLAG:
      return {
        ...state,
        resetPageOnDataChange: action.payload,
      };
    case types.CLEAR_ALL_ERROR:
      return {
        ...state,
        fetchingAllSiteError: null,
        manageOrderListData: {
          ...state.manageOrderListData,
          Errors: null,
        },
      };
    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };
    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/manageProcessOrder/reducer.js